<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" :rules="formRules" ref="queryForm" :inline="true">
          <div class="flex-box">
            <!-- <img src="../../../assets/down.png" class="down" alt=""> -->

            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{query.timeType === 1?'日':(query.timeType === 2?'周':'月')}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">日</el-dropdown-item>
                <el-dropdown-item command="3">月</el-dropdown-item>
                <el-dropdown-item command="2">周</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-form-item label="距离活动时间：" class="is-required" prop="day" style="display:flex">
              <el-input placeholder="请输入" v-model="query.day" @input="handleInput" size="small" class="input-with-select" />
            </el-form-item>
          </div>
          <el-form-item label="政策类型：" class="is-required">
            <el-select v-model="query.analysisId" placeholder="请选择" filterable clearable size="small" @change="changeAnalysis">
              <el-option v-for="(item,index) in options.analysisList" :key="index" :label="item.typeName" :value="item.idstr"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品信息：" class="is-required">
            <el-select v-model="query.goodsId" placeholder="请选择" filterable clearable size="small">
              <el-option v-for="(item,index) in options.productOptions" :key="index" :label="item.goodsName" :value="item.goodsId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户类型：">
            <el-select v-model="query.customerType" placeholder="请选择" clearable size="small">
              <el-option label="新客户" :value="0"></el-option>
              <el-option label="老客户" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户分类：">
            <el-select v-model="query.customerClassifyId" placeholder="请选择" filterable clearable size="small">
              <el-option v-for="(item,index) in options.customerClass" :key="index" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门：">
            <el-select v-model="query.deptId" placeholder="请选择" filterable clearable size="small" @change="changDepartment">
              <el-option v-for="(item,index) in options.departmentList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="技术/业务级别：">
            <el-select v-model="query.levelName" placeholder="请选择" filterable clearable size="small" @change="changeFormanceUserType">
              <el-option v-for="(item,index) in options.levelOptions" :key="index" :label="item.levelName" :value="item.levelName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人员信息：" prop="nameOrPho">
            <el-select v-model="query.nameOrPho" placeholder="手机号模糊查询" remote :remote-method="searchUsers" :loading="loading" filterable clearable size="small" @change="changeUser">
              <el-option v-for="(item,index) in options.selectOptions" :key="index" :label="item.name" :value="item.pho"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <template v-if="isShowEcharts">
        <echarts-vue :echart-data="echartData" echartName="echarts" v-if="echartData && echartData.yAxisData" />
      </template>
      <template v-if="list && list.length > 0">
        <div class="title-txt"><img src="../../../assets/down.png" class="down" alt=""></div>
        <el-table v-loading="listLoading" :data="list">
          <el-table-column label="用户信息" prop="userName" align="center" />
          <el-table-column label="用户身份" prop="identityName" align="center" />
          <el-table-column label="用户手机号" prop="userPho" align="center" />
          <el-table-column label="客户分类" prop="customerClassifyName" align="center" />
          <el-table-column label="购买产品名称" prop="goodsName" align="center" />
          <el-table-column label="购买数量" prop="goodsCount" align="center" />
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </template>
    </el-card>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination'
import DataBoardApi from '@/api/dataBoard/DataBoard'
import echartsVue from "../components/echarts.vue";
import customerClassifyApi from '@/api/config/customerClassify'
import sysDepartmentApi from '@/api/config/sysDepartment'
import customerApi from '@/api/technical/customer'
import technicianInfoApi from '@/api/technical/technicianInfo'
import customerLevelApi from '@/api/sys/customerLevel'
import { Subtr, getNthDayAfter } from '@/utils/index'
export default {
  components: {
    Pagination,
    echartsVue
  },
  data() {
    return {
      list: [],
      listLoading: true,
      total: 0,
      query: {
        timeType: 1,
        pageNo: 1,
        pageSize: 10
      },
      customerOptions: [],
      echartsData: [],
      xData: [],
      formRules: {
        day: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }]
      },
      options: {
        customerClass: [],
        departmentList: [],
        selectOptions: [],
        analysisList: [],
        productOptions: []
      },
      searchVal: '',
      isShowEcharts: false
    }
  },
  created() {
    this.getCustomerClass()
    this.getDepOption()
    this.getAnalysisList()
    this.getAllLevel()
  },
  methods: {
    handleFilter() {
      this.query = {
        timeType: 1,
        pageNo: 1,
        pageSize: 10
      }
    },
    handleInput(value) {
      let { timeType } = this.query;
      // {{query.timeType === 1?'日':(query.timeType === 2?'周':'月')}}<i class="el-icon-arrow-down el-icon--right"></i>
      // 过滤非数字字符
      let maxNum = timeType === 1 ? 90 : (timeType === 2 ? 52 : 12)
      let num = value.replace(/[^\d]/g, '');
      // 转换为数字类型，处理空字符串情况
      num = num === '' ? '' : parseInt(num, 10);

      // 限制最大值
      if (num !== '' && num > maxNum) {
        num = maxNum;
      }
      this.query.day = num === '' ? '' : num.toString();
    },
    getAllLevel() {
      customerLevelApi.getAllLevel({ getTechnicianLevel: true, getYeWuLevel: true, getCustomerLevel: false }).then(res => {
        this.options.levelOptions = res.data
      })
    },
    changeFormanceUserType() {
      this.$set(this.query, 'nameOrPho', '')
      this.options.selectOptions = []
    },
    changDepartment() {
      let { deptId } = this.query;
      let find = this.options.departmentList.find(item => item.id === deptId)
      if (find) this.query.performanceUserType = find.directorUserType === 30 ? 1 : 2
    },
    //获取政策类型
    getAnalysisList() {
      DataBoardApi.projecAnalysisTypeList().then(res => {
        res.data.forEach(item => {
          item.idstr = item.id + '_' + item.type
        })
        this.options.analysisList = res.data;
      })
    },
    changeAnalysis() {
      let { analysisId } = this.query
      let find = this.options.analysisList.find(item => item.idstr === analysisId);
      if (find) this.options.productOptions = find.goodsList || [];
      this.$set(this.query, 'goodsId', '')
    },
    // 获取部门
    getDepOption() {
      sysDepartmentApi.getMiniList().then(({ data }) => {
        this.options.departmentList = data.list
      })
    },
    //获取客户分类
    getCustomerClass() {
      customerClassifyApi.findOptions().then(res => {
        this.options.customerClass = res.data.reverse()
      })
    },
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          this.searchVal = query
          this.getKFCustomer()
          this.$set(this.query, 'nameOrPho', null)
        }, 500);
      } else {
        this.options = [];
      }
    },
    getKFCustomer() {
      let { levelName } = this.query;
      let find = this.options.levelOptions.find(item => item.levelName === levelName)
      DataBoardApi.getUserInfo({ levelId: find.levelId, nameOrPho: this.searchVal, levelType: find.type }).then(({ data }) => {
        this.options.selectOptions = data
      })
    },
    handleCommand(command) {
      this.query.timeType = +command;
      this.query.day = ''
    },
    calcQuery() {
      let params = JSON.parse(JSON.stringify(this.query))
      // params.day = params.day ? +params.day : undefined
      let find = this.options.analysisList.find(item => item.idstr === params.analysisId);
      if (find) {
        params.startTime = find.startTime
        params.endTime = getNthDayAfter(find.startTime, +params.day) + ' 23:59:59'
      }
      delete params.day
      delete params.analysisId
      return params
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let params = this.calcQuery()
      this.listLoading = true
      return DataBoardApi.projecAnalysisList(params)
        .then(data => {
          this.list = data.data.list || []
          console.log(this.list)
          this.total = data.data.total;
        }).finally(() => {
          this.listLoading = false
        })
    },
    handleQuery() {
      let { day, timeType, analysisId, goodsId } = this.query;
      if (!day) return this.$message.warning('请输入距离会议时间')
      if (!timeType) return this.$message.warning('请选择时间粒度')
      if (!analysisId) return this.$message.warning('请选择政策类型')
      if (!goodsId) return this.$message.warning('请选择产品信息')
      this.submitForm()
    },
    submitForm() {
      this.$refs["queryForm"].validate((valid) => {
        if (valid) {
          this.doQueryList({})
          this.getPaymentStatis()
        }
      })
    },

    getPaymentStatis() {
      let params = this.calcQuery()
      delete params.pageNo
      delete params.pageSize
      DataBoardApi.projecAnalysisK(params).then(({ data }) => {
        if (data.length > 0) {
          data.forEach(item => {
            item.ratio = Subtr(item.afterMoney, item.beforeMoney) / item.beforeMoney * 100;
          })
          this.calcDate(data)
          this.getEcharts(data)
          this.isShowEcharts = true
        } else {
          this.isShowEcharts = false
          this.$message.warning('暂无数据')
        }
      })
    },
    getEcharts(echartsData) {
      this.echartsData = this.synthesisSeriesData(echartsData, [
        { name: "收款", color: "#FED15C", key: "money" },
        { name: "出货", color: "#F3715B", key: "cou" },
      ], "line")
    },

    calcDate(data) {
      let { timeType } = this.query;
      let dateList = []
      if (timeType === 1) {
        data.forEach((item, index) => {
          // item.date = `第${index + 1}日`
          item.date = item.startTime.substr(0, 10).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      } else if (timeType === 2) {
        data.forEach((item, index) => {
          let date = item.startTime.substr(0, 10).replace(/\-/g, "/")
          dateList.push(`第${index + 1}周 ${date}`)
        });

      } else if (timeType === 3) {
        data.forEach(item => {
          item.date = item.startTime.substr(0, 7).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      }
      this.xData = dateList
    },

    //合成图标Y轴信息
    synthesisSeriesData(datalist, ydata, chartType) {
      let param = {}, itemStyle = {};
      if (chartType === 'line') {
        param = { type: "line", smooth: true, symbolSize: 10 };
      }
      return ydata.map(item => {
        return {
          name: item.name, ...param, data: datalist.map(it => it[item.key]), itemStyle: {
            ...itemStyle,
            color: item.color
          }
        }
      })
    }

  },
  computed: {
    echartData() {
      return {
        // legendData: item.dataList.map(it => it.title),
        xAxisData: this.xData,
        yAxisData: this.echartsData
      };
    },
  },
}
</script>
<style lang="scss" scoped>
.down {
  width: 34px;
  height: 34px;
  margin-right: 10px;
  cursor: pointer;
}
.flex-box {
  display: flex;
  flex-direction: row-reverse;
}
.el-dropdown {
  line-height: 42px;
  margin-right: 10px;
}
.title-txt {
  margin: 10px 0;
  text-align: right;
  img {
    width: 34px;
    height: 34px;
    cursor: pointer;
  }
}
</style>
